<app-side-top-bar [navigationItems]="navigationItems">
  <main>
    <div
      [ngClass]="
        isPatientActive ? 'patient-name' : 'patient-name name-not-active'
      "
    >
      <h2>{{ patientNameAndSurname }}</h2>
    </div>
    <section class="history-diagnosis-pharma">
      <header class="header">
        <div class="sections">
          <div
            class="{{ isMedicalHistorySelected }}"
            (click)="displayMedicalHistorySection()"
          >
            <h2>{{ labelService.getLabel("medical_history") }}</h2>
          </div>
          <div
            class="{{ isDiagnosisSelected }}"
            (click)="displayDiagnosisSection()"
          >
            <h2>{{ labelService.getLabel("diagnosis") }}</h2>
          </div>
          <div
            class="{{ isPharmacotherapySelected }}"
            (click)="displayPharmaSection()"
          >
            <h2>{{ labelService.getLabel("pharmacoterapy") }}</h2>
          </div>
        </div>
        <div class="header-buttons">
          @if (isDiagnosisSelected === "selected") {
            <app-button
              [icon]="'add'"
              (click)="toggleNewDiagnosisPanel()"
            ></app-button>
          }
          @if (isPharmacotherapySelected === "selected") {
            <app-button
              [icon]="'add'"
              (click)="toggleActivePrinciplesPanel()"
            ></app-button>
          }
          @if (isMedicalHistorySelected === "selected") {
            <app-button
              [icon]="modifyButtonText"
              [size]="'icon_small'"
              (click)="onModifyButtonClick()"
            ></app-button>
          }
        </div>
      </header>

      <!-- medical history section -->
      @if (isMedicalHistorySelected === "selected") {
        <section>
          <app-anamnesis
            [patientId]="patientId"
            [anamnesis]="anamnesis"
            [anamnesisClinicHistoryFields]="anamnesisClinicHistoryFields"
            [anamnesisPersonalFields]="anamnesisPersonalFields"
            [familyMembers]="familyMembers"
            [fieldIsReadOnly]="fieldIsReadOnly"
          ></app-anamnesis>
        </section>
      }

      <!-- diagnosis section -->
      @if (isDiagnosisSelected === "selected") {
        <app-diagnosis
          [patientId]="patientId"
          [diagnoses]="diagnoses"
          [isLoading]="isLoading"
          [hasModifyButtonBeenClicked]="hasModifyButtonBeenClicked"
          [showNewDiagnosisPanel]="showNewDiagnosisPanel"
          (reloadDiagnoses)="displayDiagnosisSection()"
          (toggleNewPanel)="toggleNewDiagnosisPanel()"
        ></app-diagnosis>
      }

      <!-- pharmacoterapy section -->
      @if (isPharmacotherapySelected === "selected") {
        <app-pharmacotherapy
          [patientId]="patientId"
          [pharmacotherapies]="pharmacotherapies"
          [hasModifyButtonBeenClicked]="hasModifyButtonBeenClicked"
          [showActivePrinciplesPanel]="showActivePrinciplesPanel"
          [isLoading]="isLoading"
          (reloadPharmacotherapies)="displayPharmaSection()"
          (toggleActivePrinciples)="toggleActivePrinciplesPanel()"
        ></app-pharmacotherapy>
      }
    </section>
  </main>
</app-side-top-bar>
